import { MutatingDots } from "react-loader-spinner";

type LoaderProps = {
  message?: string;
};

const Loader = ({ message = "Processing your request..." }: LoaderProps) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#1D2C56]/20 backdrop-blur-[2px]">
      <div className="flex flex-col items-center gap-2">
        <MutatingDots
          visible
          height="100"
          width="100"
          color="#1D2C56"
          secondaryColor="#66A0CD"
          ariaLabel="loading"
        />
        <p className="text-center font-sans text-lg font-semibold text-[#1D2C56]">
          {message}
        </p>
      </div>
    </div>
  );
};

export default Loader;
